<template>
  <div class="listarPedidos">
    <ul class="p-0 my-4">
      <li
        @click="detalhesPedido(pedido.id)"
        class="card px-4 py-3 mb-4 shadow btn text-left"
        v-for="(pedido, i) in objPedidos"
        :key="i"
      >
        <div class="d-flex justify-content-between flex-column flex-lg-row">
           <span
            ><small>ID</small><br />#{{pedido.id}}
            </span>
          <span
            ><small>Pedido</small><br />#{{
              formatCodigoPedido(pedido.codigoReferencia)
            }}
            </span>
          <span>
            <small>Situação</small> <br />
            <span class="badge-light">{{ pedido.statusExibicao }}</span>
          </span>
          <span
            ><small>Data do pedido</small><br />{{
              data(pedido.dataRegistro)
            }}</span
          >
          <span
            ><small>Valor<br /> </small>R$
            {{ formatPrice(pedido.valorTotal) }}</span
          >
          <span class="align-self-center h3" style="color: var(--cor-principal)"
            >&#10097;</span
          >
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import VueMoment from "vue-moment";
Vue.use(VueMoment);

export default {
  name: "ListarPedidos",
  props: ["objPedidos"],
  data() {
    return {};
  },
  methods: {
    data(data) {
      return this.$moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
    formatCodigoPedido(codigoReferencia) {
      return codigoReferencia == null
        ? ""
        : codigoReferencia.toUpperCase().substring(0, 8);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    statusEntrega(str) {
      return str.replace("_", " ");
    },
    statusClass(str) {
      switch (str) {
        case "AGUARDANDO_PROCESSAMENTO":
        case "ENVIANDO":
          return "badge-primary";
        case "CANCELADO":
          return "badge-danger";
        case "ENTREGUE":
          return "badge-success";
        default:
          return "badge-light";
      }
    },
    detalhesPedido(id) {
      this.$router.push(`/pedidos/${id}`);
    }
  }
};
</script>

<style scoped lang="scss"></style>
